import { Switch, Route } from "wouter";
import { queryClient } from "./lib/queryClient";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Layout from "@/components/layout";
import CookieBanner from "@/components/cookie-banner";
import Home from "@/pages/home";
import { lazy, Suspense, useEffect } from "react";
import { useLocation } from "wouter";

const Urgent = lazy(() => import("@/pages/urgent"));
const Standard = lazy(() => import("@/pages/standard"));
const Manufacturers = lazy(() => import("@/pages/manufacturers"));
const Contact = lazy(() => import("@/pages/contact"));
const FAQ = lazy(() => import("@/pages/faq"));
const LegalNotice = lazy(() => import("@/pages/legal-notice"));
const Privacy = lazy(() => import("@/pages/privacy"));
const CookiesPolicy = lazy(() => import("@/pages/cookies-policy"));
const NotFound = lazy(() => import("@/pages/not-found"));
const ErrorPage = lazy(() => import("@/pages/error"));

function ScrollToTop() {
  const [location] = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);
  return null;
}

function PageLoader() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
    </div>
  );
}

function Router() {
  return (
    <Suspense fallback={<PageLoader />}>
      <Switch>
        <Route path="/" component={Home} />
        <Route path="/servicio-urgente" component={Urgent} />
        <Route path="/servicio-estandar" component={Standard} />
        <Route path="/fabricantes" component={Manufacturers} />
        <Route path="/contacto" component={Contact} />
        <Route path="/faq" component={FAQ} />
        <Route path="/aviso-legal" component={LegalNotice} />
        <Route path="/politica-privacidad" component={Privacy} />
        <Route path="/politica-cookies" component={CookiesPolicy} />
        <Route path="/error" component={ErrorPage} />
        <Route component={NotFound} />
      </Switch>
    </Suspense>
  );
}

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Layout>
          <ScrollToTop />
          <Router />
        </Layout>
        <CookieBanner />
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  );
}

export default App;
